<template>
  <div class="w-full h-full flex flex-col items-center justify-center p-8">
    <div
      class="w-2/3 max-w-sm -mt-24 pointer-events-none lottieContainer min-h-24"
    >
      <LottieComponent :src="$constants.FEE.LOTTIES.LOADING_ERROR" loop />
    </div>
    <div class="py-2"></div>
    <div class="text-center text-2xl font-bold">Aucun frais trouvé</div>
    <div class="py-1"></div>
    <div class="text-center text-lg">
      Aucun frais disponible pour le moment
    </div>
  </div>
</template>
